export class ValidationErrors {
    errors: Record<string, string> = {}
    groups: Record<string, number> = {}

    constructor(errors: Record<string, string>) {
        this.errors = errors

        // Extract group counters once so group-level UI can check nested validation cheaply.
        for (const errorPath in this.errors) {
            const pathes = errorPath.split('.')
            pathes.pop()

            if (pathes.length === 0) {
                const key = '#root'
                if (!this.groups[key]) {
                    this.groups[key] = 0
                }

                this.groups[key] += 1
            } else {
                pathes.forEach((_, pathIndex) => {
                    const key = pathes.slice(0, pathIndex + 1).join('.')
                    if (!this.groups[key]) {
                        this.groups[key] = 0
                    }

                    this.groups[key] += 1
                })
            }
        }
    }

    getError(name?: string | undefined, path?: string | undefined) {
        const fullPath = this.getFullPath(name, path)

        if (!fullPath) {
            return ''
        }

        return this.errors[fullPath] || ''
    }

    getErrorBySuffix(name?: string | undefined, path?: string | undefined) {
        const fullPath = this.getFullPath(name, path)

        if (!fullPath) {
            return ''
        }

        const suffix = `.${fullPath}`
        const matches = Object.entries(this.errors).filter(([errorPath]) => errorPath.endsWith(suffix))

        return matches.length === 1 ? (matches[0]?.[1] ?? '') : ''
    }

    hasError(name?: string | undefined, path?: string | undefined) {
        return this.getError(name, path) !== ''
    }

    hasGroupError(name?: string | undefined, path?: string | undefined) {
        return this.getGroupErrorCount(name, path) > 0
    }

    getGroupErrorCount(name?: string | undefined, path?: string | undefined) {
        const fullPath = this.getFullPath(name, path)

        if (!fullPath) {
            return 0
        }

        return this.groups[fullPath] ?? 0
    }

    getGroupErrors(path: string, filter?: (fieldId: string) => boolean) {
        return Object.entries(this.errors)
            .filter(([key]) => key.startsWith(path) && !!filter?.(key.split('.').pop() ?? ''))
            .reduce(
                (result, [key, value]) => {
                    result[key] = value
                    return result
                },
                {} as Record<string, string>
            )
    }

    private getFullPath(name?: string | undefined, path?: string | undefined) {
        if (name && path) {
            return `${name}.${path}`
        } else if (name) {
            return name
        } else if (path) {
            return path
        } else {
            return ''
        }
    }
}
